import { render, staticRenderFns } from "./RouteShow.vue?vue&type=template&id=0a54354a"
import script from "./RouteShow.vue?vue&type=script&lang=js"
export * from "./RouteShow.vue?vue&type=script&lang=js"
import style0 from "./RouteShow.vue?vue&type=style&index=0&id=0a54354a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports